module.exports = __webpack_public_path__ + "media/images/icon-contact-dots-1b556c2665d3fe502838259960101522.svg";